import axios from "axios";
import { useEffect, useState } from "react";
import localize from "../../../common/localize";
import useGlobalContext from "../../../hooks/useGlobalContext";
import { List } from "@mui/material";
import NotificationItem from "../../../components/common/NotificationItem";
import BillsItem from "../../relatedBills/components/BillsItem";

export default function ClientBills({ clientModelData }) {
  const { config, BILL_ENDPOINT } = useGlobalContext();
  const [billsData, setBillsData] = useState([]);

  const getBills = async () => {
    const requestConfig = {
      ...config,
    };
    requestConfig.headers.pagination = -1;
    const data = await axios.get(
      `${BILL_ENDPOINT}/client/${clientModelData?.Id}`,
      requestConfig
    );
    setBillsData(data?.data?.Data);
  };

  useEffect(() => {
    getBills();
  }, []);

  return (
    <div style={{ width: "100%" }}>
      <List className="flex flex-col gap-2 w-full">
        {billsData && billsData.length > 0 ? (
          billsData.map((bill) => <BillsItem bill={bill} />)
        ) : (
          <NotificationItem notification={{ message: localize.no_data }} />
        )}
      </List>
    </div>
  );
}
